import { useMemo } from 'react';
import endpoints from '@services/api/endpoints';
import type { VendorScheduleSearchResponse } from '@services/api/types';
import useFetch from '@services/api/useFetch';
import type { VendorScheduleRequest } from 'types/vendors';

export const useScheduleApi = () => {
  const api = useFetch();
  return useMemo(() => {
    return {
      async getOrganizationAppointments({
        rows = 24,
        sector = 'trucks',
        ...query
      }: VendorScheduleRequest): Promise<VendorScheduleSearchResponse> {
        const data = await api.get(endpoints.vendors.orderingSchedules, {
          rows,
          sector,
          ...query,
        });
        return data;
      },
    };
  }, [api]);
};

export const scheduleApiKeys = {
  all: ['schedule'] as const,
  getOrganizationAppointments: (organizationId: string) =>
    [
      ...scheduleApiKeys.all,
      'organization-appointments',
      organizationId,
    ] as const,
};
